(function () {
  'use strict';

  angular.module('app').controller('EntityBusinessInfoController', EntityBusinessInfoController);

  EntityBusinessInfoController.$inject = ['$scope', 'EntityService', 'constants', 'CoachService',
    '$routeParams', 'ModalService'];

  function EntityBusinessInfoController($scope, EntityService, constants, CoachService, $routeParams,
                                        ModalService) {
    const vm = this;
    vm.entityId = $scope.entityId;
    vm.spinner = $scope.spinner;
    vm.businessInfo = {};
    vm.initialBusinessInfo = angular.copy(vm.businessInfo);
    vm.states = constants.states;
    vm.entityTypeOptions = constants.entityTypeOptions;
    vm.ENTITY_TYPES = constants.enums.entityTypes;
    vm.corporationTypes = constants.corporationTypes;
    vm.businessTypes = constants.businessTypes;
    vm.isStripeConnected = !!$routeParams.isStripeConnected;
    vm.enums = constants.enums;

    vm.getBusinessInfo = getBusinessInfo;
    vm.getParentEntities = getParentEntities;
    vm.onEntityTypeChange = onEntityTypeChange;
    vm.checkEmailUnique = checkEmailUnique;
    vm.save = save;

    vm.$onInit = () => {
      vm.getBusinessInfo();
    };

    function getBusinessInfo() {
      return new Promise(resolve => {
        vm.spinner.active = true;
        EntityService.getBusinessDetails(vm.entityId)
          .then(res => {
            if (res.status === 200) {
              vm.businessInfo = res.data;
              vm.initialBusinessInfo = angular.copy(res.data);
              resolve(true);
            }
          })
          .finally(() => vm.spinner.active = false);
      });
    }

    function getParentEntities() {
      EntityService.getParentEntities().then(res => {
        if (res.status === 200) {
          vm.parentEntities = res.data;
        }
      });
    }

    function onEntityTypeChange() {
      const entityTypesWithDefaultOffSubscription = [vm.ENTITY_TYPES.SCHOLASTIC];
      const isSubscriptionDefaultOff = entityTypesWithDefaultOffSubscription.includes(vm.businessInfo.entityType);

      vm.isChildEntity = vm.businessInfo.entityType === vm.ENTITY_TYPES.SCHOOL;

      vm.businessInfo.isSubscriptionOn = !vm.isChildEntity && !isSubscriptionDefaultOff;
    }

    function checkEmailUnique(form) {
      const isEmailChanged = vm.businessInfo.userEmail !== vm.initialBusinessInfo.userEmail;

      if (vm.businessInfo.userEmail && isEmailChanged) {
        CoachService.checkUserEmail(vm.businessInfo.userEmail).then(function (res) {
          form["userEmail"].$setValidity("duplicate", res.status === 404);
        });
      } else {
        form["userEmail"].$setValidity("duplicate", true);
      }
    }

    function save() {
      return new Promise(resolve => {
        vm.spinner.active = true;
        EntityService.editBusinessDetails(vm.entityId, vm.businessInfo)
          .then(res => {
            if (res.status === 200) {
              resolve(true);
              vm.initialBusinessInfo = angular.copy(vm.businessInfo);
              ModalService.savedChanges();
            }
          })
          .finally(() => vm.spinner.active = false);
      });
    }
  }

})();
